module.exports = [
  {
    group: 'hair_services',
    roles: ['hairstylist', 'shampooist', 'colorist', 'barber', 'hairextensions_specialist']
  },
  {
    group: 'nail_services',
    roles: ['nail_technician', 'manicurist', 'pedicurist']
  },
  {
    group: 'beauty_aesthetics',
    roles: [
      'esthetician',
      'cosmetologist',
      'beautician',
      'makeup_artist',
      'permanent_makeup_artist',
      'microblading_specialist',
      'eyelash_technician',
      'eyebrow_specialist',
      'waxing_specialist',
      'facial_specialist',
      'microdermabrasion_specialist',
      'chemical_peel_specialist',
      'skincare_specialist',
      'anti_aging_specialist',
      'esthetic_cosmetologist'
    ]
  },
  {
    group: 'massage_bodywork',
    roles: [
      'massage_therapist',
      'masseur',
      'aromatherapist',
      'reflexologist',
      'body_wrap_specialist',
      'mud_therapy_specialist',
      'hot_stone_therapist',
      'lymphatic_drainage_therapist',
      'cupping_therapist'
    ]
  },
  {
    group: 'spa_wellness',
    roles: ['sauna_master', 'hydrotherapy_specialist', 'steam_master']
  },
  {
    group: 'fitness_movement',
    roles: [
      'personal_trainer',
      'yoga_instructor',
      'pilates_instructor',
      'fitness_instructor',
      'dance_instructor',
      'martial_arts_instructor',
      'swimming_instructor',
      'crossfit_trainer',
      'spinning_instructor',
      'aerobics_instructor',
      'stretching_specialist',
      'mobility_specialist',
      'instructor'
    ]
  },
  {
    group: 'medical_healthcare',
    roles: [
      'doctor',
      'dentist',
      'podiatrists',
      'laser_hair_removal_technician',
      'botox_specialist',
      'dermal_filler_specialist'
    ]
  },
  {
    group: 'therapeutic_services',
    roles: [
      'psychotherapist',
      'psychologist',
      'kinesiotherapist',
      'kinesiologist',
      'physical_therapist',
      'occupational_therapist',
      'speech_therapist',
      'art_therapist',
      'music_therapist',
      'couples_therapist',
      'family_therapist'
    ]
  },
  {
    group: 'alternative_holistic',
    roles: [
      'acupuncturist',
      'chiropractor',
      'osteopath',
      'reiki_practitioner',
      'energy_healer',
      'crystal_therapist',
      'sound_therapist',
      'hypnotherapist'
    ]
  },
  {
    group: 'wellness_coaching',
    roles: [
      'meditation_instructor',
      'breathwork_facilitator',
      'life_coach',
      'wellness_coach',
      'nutrition_counselor',
      'dietitian',
      'stress_management_consultant'
    ]
  },
  {
    group: 'coaching_training',
    roles: [
      'business_coach',
      'career_coach',
      'executive_coach',
      'leadership_coach',
      'relationship_coach',
      'parenting_coach',
      'financial_coach',
      'public_speaking_coach',
      'presentation_coach',
      'communication_coach',
      'confidence_coach',
      'productivity_coach',
      'time_management_coach',
      'goal_setting_coach',
      'accountability_coach'
    ]
  },
  {
    group: 'driving_vehicle_training',
    roles: [
      'driving_instructor',
      'motorcycle_instructor',
      'truck_driving_instructor',
      'defensive_driving_instructor',
      'racing_instructor',
      'boat_instructor',
      'pilot_instructor'
    ]
  },
  {
    group: 'creative_media',
    roles: [
      'photographer',
      'videographer',
      'wedding_photographer',
      'portrait_photographer',
      'event_photographer',
      'product_photographer',
      'drone_operator'
    ]
  },
  {
    group: 'music_arts',
    roles: [
      'music_teacher',
      'piano_teacher',
      'guitar_teacher',
      'violin_teacher',
      'voice_coach',
      'singing_teacher',
      'drum_teacher',
      'art_teacher',
      'painting_instructor',
      'drawing_teacher',
      'sculpture_instructor',
      'pottery_teacher',
      'crafts_instructor'
    ]
  },
  {
    group: 'language_education',
    roles: [
      'language_tutor',
      'english_tutor',
      'spanish_tutor',
      'french_tutor',
      'math_tutor',
      'science_tutor',
      'history_tutor',
      'test_prep_tutor',
      'academic_tutor',
      'homework_helper',
      'study_skills_coach'
    ]
  },
  {
    group: 'event_services',
    roles: [
      'event_planner',
      'wedding_planner',
      'party_planner',
      'dj',
      'mc_host',
      'entertainer',
      'magician',
      'clown',
      'face_painter',
      'balloon_artist',
      'catering_chef',
      'bartender',
      'server',
      'event_coordinator'
    ]
  },
  {
    group: 'outdoor_recreation',
    roles: [
      'hiking_guide',
      'mountain_guide',
      'ski_instructor',
      'snowboard_instructor',
      'surf_instructor',
      'climbing_instructor',
      'kayak_instructor',
      'fishing_guide',
      'hunting_guide',
      'camping_guide',
      'nature_guide',
      'tour_guide'
    ]
  },
  {
    group: 'specialized_services',
    roles: [
      'tattoo_master',
      'fertility_specialist',
      'sleep_specialist',
      'image_consultant',
      'stylist',
      'wardrobe_consultant',
      'personal_shopper',
      'etiquette_coach',
      'protocol_specialist'
    ]
  },
  {
    group: 'other',
    roles: ['other']
  }
]
